//# sourceMappingURL=typography.mjs.map
/// <reference types="./typography.d.mts" />
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $display from "../../ds/typography/display.mjs";
import * as $text from "../../ds/typography/text.mjs";
import { toList, CustomType as $CustomType, makeError } from "../../gleam.mjs";

const FILEPATH = "src/ds/components/typography.gleam";

class Xxl extends $CustomType {}

class Xl extends $CustomType {}

class Lg extends $CustomType {}

class Md extends $CustomType {}

class Sm extends $CustomType {}

class Xs extends $CustomType {}

export const regular = $text.regular;

export const medium = $text.medium;

export const xxl = /* @__PURE__ */ new Xxl();

export const xl = /* @__PURE__ */ new Xl();

export const lg = /* @__PURE__ */ new Lg();

export const md = /* @__PURE__ */ new Md();

export const sm = /* @__PURE__ */ new Sm();

export const xs = /* @__PURE__ */ new Xs();

export function text(size, weight, text) {
  let _block;
  if (size instanceof Xxl) {
    throw makeError(
      "panic",
      FILEPATH,
      "ds/components/typography",
      38,
      "text",
      "No XXL for text",
      {}
    )
  } else if (size instanceof Xl) {
    _block = $text.xl(weight);
  } else if (size instanceof Lg) {
    _block = $text.lg(weight);
  } else if (size instanceof Md) {
    _block = $text.md(weight);
  } else if (size instanceof Sm) {
    _block = $text.sm(weight);
  } else {
    _block = $text.xs(weight);
  }
  let _pipe = _block;
  return $h.span(_pipe, toList([]), toList([$h.text(text)]));
}

export function colored(color, text) {
  let _pipe = $css.class$(toList([$css.color(color)]));
  return $h.span(_pipe, toList([]), toList([$h.text(text)]));
}

export function display(size, text) {
  let _block;
  if (size instanceof Xxl) {
    _block = $display.xxl();
  } else if (size instanceof Xl) {
    _block = $display.xl();
  } else if (size instanceof Lg) {
    _block = $display.lg();
  } else if (size instanceof Md) {
    _block = $display.md();
  } else if (size instanceof Sm) {
    _block = $display.sm();
  } else {
    _block = $display.xs();
  }
  let _pipe = _block;
  return $h.span(_pipe, toList([]), toList([$h.text(text)]));
}

export function h1(size, text) {
  let _block;
  if (size instanceof Xxl) {
    _block = $display.xxl();
  } else if (size instanceof Xl) {
    _block = $display.xl();
  } else if (size instanceof Lg) {
    _block = $display.lg();
  } else if (size instanceof Md) {
    _block = $display.md();
  } else if (size instanceof Sm) {
    _block = $display.sm();
  } else {
    _block = $display.xs();
  }
  let _pipe = _block;
  return $h.h1(_pipe, toList([]), toList([$h.text(text)]));
}

export function h2(size, text) {
  let _block;
  if (size instanceof Xxl) {
    _block = $display.xxl();
  } else if (size instanceof Xl) {
    _block = $display.xl();
  } else if (size instanceof Lg) {
    _block = $display.lg();
  } else if (size instanceof Md) {
    _block = $display.md();
  } else if (size instanceof Sm) {
    _block = $display.sm();
  } else {
    _block = $display.xs();
  }
  let _pipe = _block;
  return $h.h2(_pipe, toList([]), toList([$h.text(text)]));
}

export function h3(size, text) {
  let _block;
  if (size instanceof Xxl) {
    _block = $display.xxl();
  } else if (size instanceof Xl) {
    _block = $display.xl();
  } else if (size instanceof Lg) {
    _block = $display.lg();
  } else if (size instanceof Md) {
    _block = $display.md();
  } else if (size instanceof Sm) {
    _block = $display.sm();
  } else {
    _block = $display.xs();
  }
  let _pipe = _block;
  return $h.h3(_pipe, toList([]), toList([$h.text(text)]));
}

export function h4(size, text) {
  let _block;
  if (size instanceof Xxl) {
    _block = $display.xxl();
  } else if (size instanceof Xl) {
    _block = $display.xl();
  } else if (size instanceof Lg) {
    _block = $display.lg();
  } else if (size instanceof Md) {
    _block = $display.md();
  } else if (size instanceof Sm) {
    _block = $display.sm();
  } else {
    _block = $display.xs();
  }
  let _pipe = _block;
  return $h.h4(_pipe, toList([]), toList([$h.text(text)]));
}

export function h5(size, text) {
  let _block;
  if (size instanceof Xxl) {
    _block = $display.xxl();
  } else if (size instanceof Xl) {
    _block = $display.xl();
  } else if (size instanceof Lg) {
    _block = $display.lg();
  } else if (size instanceof Md) {
    _block = $display.md();
  } else if (size instanceof Sm) {
    _block = $display.sm();
  } else {
    _block = $display.xs();
  }
  let _pipe = _block;
  return $h.h5(_pipe, toList([]), toList([$h.text(text)]));
}

export function h6(size, text) {
  let _block;
  if (size instanceof Xxl) {
    _block = $display.xxl();
  } else if (size instanceof Xl) {
    _block = $display.xl();
  } else if (size instanceof Lg) {
    _block = $display.lg();
  } else if (size instanceof Md) {
    _block = $display.md();
  } else if (size instanceof Sm) {
    _block = $display.sm();
  } else {
    _block = $display.xs();
  }
  let _pipe = _block;
  return $h.h6(_pipe, toList([]), toList([$h.text(text)]));
}
